// extracted by mini-css-extract-plugin
export default {"page_404_header":"cd478a","glitch":"a48efc","glitch-effect-animation":"b08501"};